import styled from 'styled-components';
import { RawButton } from '../../../../CommonComponents/OPL/Button/Button.styles';

interface AccountButtonProps {
  isSelected: boolean;
}

export const AccountButton = styled(RawButton)<AccountButtonProps>(({ theme, isSelected }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '16px 16px 16px 12px',
  gap: 8,
  borderBottom: `1px solid ${
    isSelected ? theme.colors.primary['200'] : theme.colors.neutral['200']
  }`,
  width: '100%',
  borderRadius: 0,
  alignItems: 'stretch',
  backgroundColor: isSelected ? theme.colors.primary['100'] : theme.colors.bg,
  position: 'relative',
  transition: `background ${theme.transitions.normal}, color ${theme.transitions.normal}`,
  overflow: 'unset',

  '&:not(.disabled):focus': {
    backgroundColor: isSelected ? theme.colors.primary['100'] : theme.colors.bg,
  },

  '&:not(.disabled):hover': {
    backgroundColor: isSelected ? theme.colors.primary['100'] : theme.colors.neutral['100'],
  },

  '&:not(.disabled):active': {
    backgroundColor: isSelected ? theme.colors.primary['100'] : theme.colors.neutral['100'],
  },

  '&::before': {
    content: '""',
    position: 'absolute',
    left: 0,
    bottom: -1,
    width: 12,
    height: 1,
    backgroundColor: theme.colors.bg,
  },

  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    width: 3,
    backgroundColor: isSelected ? theme.colors.primary['500'] : 'transparent',
  },

  '&:last-of-type': {
    '&::before': {
      display: 'none',
    },
  },
}));
